<app-tab-bar [tabs]="tabList" [currentTab]="'documentation'" (updateCurrentIndex)="openTab($event)"></app-tab-bar>
<div class="site-content">
  <div class="section">
    <b> IMPORTANT NOTICE </b>: This page is no longer being updated. Methodologies can now be found
    <a href="https://www.spglobal.com/spdji/en/search/?query=&activeTab=all&ContentType=Methodology&AssetFamily=all-fixed-income">here</a>.
    All additional news and information can now be found
    <a href="https://www.spglobal.com/spdji/en/search/?query=&activeTab=all&ContentType=BenchmarkStatements&ContentType=MethodologyConsultation&ContentType=CountryClassifications&ContentType=IndexCalendars&ContentType=Section871mInformation&ContentType=SectorClassifications&ContentType=SupplementalMethodologies&ContentType=TickersAndReferenceInformation&ContentType=CorporateNews&ContentType=Announcement&ContentType=IndexLaunch&ContentType=IndexDecommissions&ContentType=advisoryAnnouncements&ContentType=tradingAnnouncements&ContentType=otherFixedIncomeResources&AssetFamily=all-fixed-income">
      here</a>
  </div>
  <div class="section" style="display: flex; padding: 0; min-height: 500px" *ngIf="docStatus">
  <div class="categories">
      <div class="category" *ngIf="pageName === 'iBoxx'" [ngClass]="{'selected' : category === 'Holiday Calendars'}"
           (click)="category = 'Holiday Calendars'; getObjectsFromS3()"><span>Holiday Calendars</span></div>
      <div class="category" *ngIf="pageName === 'iBoxx' && indexType === 'all'" [ngClass]="{'selected' : category === 'Methodology'}"
           (click)="category = 'Methodology'; getObjectsFromS3()"><span>Methodology</span></div>
      <div class="category" *ngIf="pageName === 'iBoxx' && indexType === 'all'" [ngClass]="{'selected' : category === 'Rules Benchmark'}"
           (click)="category = 'Rules Benchmark'; getObjectsFromS3()"><span>Rules Benchmark</span></div>
      <div class="category" *ngIf="pageName === 'iBoxx' && indexType === 'all'" [ngClass]="{'selected' : category === 'Rules Liquid'}"
           (click)="category = 'Rules Liquid'; getObjectsFromS3()"><span>Rules Liquid</span></div>
      <div class="category" *ngIf="pageName === 'iBoxx' && (indexType === 'all' || indexType === 'trs')" [ngClass]="{'selected' : category === 'Tradable - Standardized TRS'}"
           (click)="category = 'Tradable - Standardized TRS'; getObjectsFromS3()"><span>Tradable - Standardized TRS</span></div>
      <div class="category" *ngIf="pageName === 'iBoxx' && (indexType === 'all' || indexType === 'futures')" [ngClass]="{'selected' : category === 'Tradable - Futures'}"
           (click)="category = 'Tradable - Futures'; getObjectsFromS3()"><span>Tradable - Futures</span></div>
      <div class="category" *ngIf="pageName === 'iBoxx' && (indexType === 'all' || indexType === 'esg')" [ngClass]="{'selected' : category === 'ESG/Sustainable'}"
           (click)="category = 'ESG/Sustainable'; getObjectsFromS3()"><span>ESG/Sustainable</span></div>
      <div class="category" *ngIf="pageName === 'Carbon'" [ngClass]="{'selected' : category === 'Documentation'}"
           (click)="category = 'Documentation'; getObjectsFromS3()"><span>Documentation</span></div>
      <div class="category" *ngIf="pageName === 'EMIX'" [ngClass]="{'selected' : category === 'General Methodology Documents'}"
           (click)="category = 'General Methodology Documents'; getObjectsFromS3()"><span>General Methodology Documents</span></div>
      <div class="category" *ngIf="pageName === 'EMIX'" [ngClass]="{'selected' : category === 'Methodologies'}"
           (click)="category = 'Methodologies'; getObjectsFromS3()"><span>Methodologies</span></div>
      <div class="category" *ngIf="pageName === 'EMIX'" [ngClass]="{'selected' : category === 'List of EMIX Indices'}"
           (click)="category = 'List of EMIX Indices'; getObjectsFromS3()"><span>List of EMIX Indices</span></div>
    </div>
    <div class="reports">
      <div id="searchBarLi" class="search-input-group search-group" style="display: flex; padding-top: 10px">
        <input type="text" class="short typeahead" name="x" id="EntitySearchBox" (keyup)="searchTerm($event)"
               placeholder="Search by Document Name." [(ngModel)]="searchInput">
        <div class="predictiveSearch values" *ngIf="searched && searchResult.length > 0"
             [ngStyle]="{'display': searched ? 'block' : 'none'}">
          <table class="results" [ngStyle]="{'display': searched ? 'block' : 'none'}"
                 style="table-layout: fixed; margin-bottom: 0; width: 100%; max-height: 400px; overflow: scroll">
            <tr *ngFor="let searchField of searchResult">
              <td>Document Name: <span><span class="link"
                                          (click)="openDocument(searchField)"
                                          [innerHTML]="searchField"></span></span></td>
            </tr>
          </table>
        </div>
        <div class="predictiveSearch values no-search-found" *ngIf="searched && searchResult.length === 0"
             style="display: block">
          No Result <span *ngIf="searchInput"> for '{{searchInput}}'</span> found.
        </div>
        <div class="input-group-btn">
          <i class="site-icon-search-button"></i>
        </div>
      </div>
      <div class="heading-text" style="padding: 10px 0">{{category}}</div>
      <div class="report" *ngIf="documents.length === 0"> No documents to show.</div>
      <ul *ngIf="!category.includes('Rules') && documents.length > 0" class="report">
        <li *ngFor="let doc of documents" (click)="openDocument(doc)">
          <i class="site-icon-pdf"></i>
          <span class="file-name link">{{getDisplayName(doc)}}</span>
        </li>
      </ul>
      <div *ngIf="category.includes('Rules') && documents.length > 0">
        <nav class="nav-tabs">
          <ng-container>
            <a class="nav-link pointer-cursor" *ngFor="let rules of rulesBenchmark"
               [ngClass]="{'active': currentRegion === rules.region}" title="{{rules.region}}"
               (click)="currentRegion = rules.region">{{rules.region}}</a>
          </ng-container>
        </nav>
        <div class="report" style="margin: 10px 0">
          <div *ngFor="let rules of rulesBenchmark">
            <div style="padding: 0 70px" *ngIf="rules.region === currentRegion">
              <div *ngFor="let rule of rules.families">
                <span>{{rule}}</span>
                <div style="display: flex">
                  <app-ihsm-dropdown-lib style="width: 550px;" dropdownType="single"
                                         [data]="getDocumentListFor(rule, rules.documents)"
                                         (filterAppliedEvent)="openDocument($event.value)"></app-ihsm-dropdown-lib>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
